//#region import
import { React, useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useCookies } from 'react-cookie';
import axios from 'axios';
import Home from './Home';
import {
  BrowserRouter,
  Route,
  Routes,
  useParams,
  useNavigate
} from 'react-router-dom';
import {
  Snackbar,
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import moment from 'moment'
//#endregion

//#region style
const useStyles = makeStyles((theme) => ({
  appBar: {
    display: 'flex',
    height: '50px',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    backgroundColor: '#883355',
    color: 'white'
  },
  link: {
    textTransform: 'none',
    textDecoration: 'none',
    color: 'black',
    [theme.breakpoints.up('md')]: {
      fontSize: 'large'
    }
  },
  button: {
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  icon: {
    [theme.breakpoints.up('md')]: {
      width: '35px',
      height: '35px',
      margin: '0px 20px'
    },
    width: '25px',
    height: '25px',
    margin: '0px 10px'
  },
  accordion: {
    minHeight: '50px'
  }
}));
//#endregion

const apiUrl = window.apiUrl
const SSOUrl = window.SSOUrl

export default function App() {

  const classes = useStyles()

  const [status, setStatus] = useState({})
  const [snackbar, setSnackbar] = useState(false);
  function updateStatus(severity, message) {
    setStatus({ severity, message })
    setSnackbar(true)
  }

  const [tokenCookie, setTokenCookie, deleteTokenCookie] = useCookies(['devicemanagertoken'])
  const [token, setToken] = useState()
  function tokenSetter(input) {
    setToken(input)
  }

  useEffect(() => {
    if (tokenCookie['devicemanagertoken'] != null && tokenCookie['devicemanagertoken'] !== '') {
      setToken(tokenCookie['devicemanagertoken'])
    }
  }, []);

  if (!token && !tokenCookie['devicemanagertoken'] && !window.location.pathname.includes('Token/')) {
    window.location.href = SSOUrl
  }

  async function httpcall(type, url, payload, callback) {    
    if (token) {
      var content;
      try {
        switch (type) {
          case 'get': {
            content = await axios.get(apiUrl + url, { headers: { token: token } })
              .catch(error => { throw { status: error.response.status, data: error.response.data } });
            callback(content.data)
            break
          }
          case 'post': {
            content = await axios.post(apiUrl + url, payload ? payload : null)
            callback()
            break
          }
          case 'update': {
            content = await axios.update(apiUrl + url)
            callback()
            break
          }
          case 'delete': {
            content = await axios.delete(apiUrl + url)
            callback()
            break
          }
        }
      }
      catch (exception) {
        if (exception.status && exception.status === 401) {
          deleteTokenCookie('devicemanagertoken')
          window.location.href = SSOUrl
        } else if (exception.status && exception.status === 412) {
          deleteTokenCookie('devicemanagertoken')
          updateStatus('error', 'SSO exception on API side')
          window.location.href = SSOUrl
        }  else if (exception.status && exception.status === 403) {
          updateStatus('warning', 'This action is forbiden')
        } else {
          updateStatus('error', 'An error occured ' + exception.status + ' ' + exception.message)
        }
      }
    }
  }

  return (<>
    <BrowserRouter>
      <div>
        {!window.location.pathname.includes('Device/') ?
          <div className={classes.appBar}>
            <h3>
              Device Manager
            </h3>
          </div>
          : <></>}
        <Routes>
          <Route path='/Token/:token' element={<TokenHandler setter={tokenSetter} />} />
          {token ?
            <Route path='/' element={<Home statusUpdate={updateStatus} httpcall={httpcall} />} />
          : <></>}
        </Routes>
      </div>
    </BrowserRouter>
    <Snackbar
      open={snackbar}
      autoHideDuration={3000}
      onClose={() => { setSnackbar(false) }}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
      <Alert severity={status.severity ? status.severity : 'error'} variant='filled'>
        {status.message ? status.message : 'error, no data transmited to this box'}
      </Alert>
    </Snackbar>
  </>)
}

const TokenHandler = (props) => {
  let { token } = useParams()
  const navigate = useNavigate()
  const [tokenCookie, setTokenCookie, deleteTokenCookie] = useCookies(['devicemanagertoken'])
  const [tempToken, setTempToken] = useState(null)

  useEffect(() => {
    if (tempToken == null) {
      setTempToken(token)
    } else {
      setTokenCookie('devicemanagertoken', tempToken, { path: '/', expires: moment(new Date()).add(15, 'days').toDate()});
      props.setter(tempToken)
      navigate('/')
    }
  }, [tempToken]);

  return (
    <></>
  )
}
